import { render, staticRenderFns } from "./observe-list.vue?vue&type=template&id=bfff655a&scoped=true&"
import script from "./observe-list.vue?vue&type=script&lang=js&"
export * from "./observe-list.vue?vue&type=script&lang=js&"
import style0 from "./observe-list.vue?vue&type=style&index=0&id=bfff655a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfff655a",
  null
  
)

export default component.exports